import React from "react";
import axios from "axios";
import { Formik, Form, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

export default function AddUser() {
  const navigate = useNavigate();

  return (
    <div className="main-card">
      <ToastContainer />

      <h2>Add User</h2>

      <Formik
        initialValues={{
          username: "",
          email: "",
          usertype: "user",
          status: 1
        }}
        onSubmit={async (values) => {
          try {
            await axios.post(
              `${process.env.REACT_APP_API_URL}users/insertuser`,
              {
                username: values.username,
                email: values.email,
                mobile: "9999999999",
                usertype: values.usertype,
                status: values.status
              }
            );

            toast.success("User added successfully");

            setTimeout(() => {
              navigate("/users");
            }, 1000);

          } catch (err) {
            toast.error("Failed to add user");
          }
        }}
      >
        <Form>
          <div>
            <label>Username</label>
            <Field name="username" className="form-control" />
          </div>

          <div>
            <label>Email</label>
            <Field name="email" className="form-control" />
          </div>

          <div>
            <label>User Type</label>
            <Field as="select" name="usertype" className="form-control">
              <option value="user">User</option>
              <option value="admin">Admin</option>
              <option value="contentadmin">Content Admin</option>
            </Field>
          </div>

          <div>
            <label>Status</label>
            <Field as="select" name="status" className="form-control">
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </Field>
          </div>

          <button type="submit" className="btn btn-primary mt-3">
            Save User
          </button>
        </Form>
      </Formik>
    </div>
  );
}